import _ from 'lodash';

import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Stack,
  Typography
} from '@mui/material';

import { CheckCircle } from '@mui/icons-material';
import {
  Price,
  useProductsSectionQuery
} from 'generated/graphql';

import imgLogo from 'assets/CompanyLogoFull.svg';



export type ProductsSectionProps = {
  disableButtons?: boolean;
  onSelectPrice?: (price: Price) => void;
};

export const FC = (props: ProductsSectionProps) => {
  const { data } = useProductsSectionQuery();

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      pt: '6rem',
      pb: '4rem',
      position: 'relative',
      background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.00) 36.97%, #FFF 100.82%), linear-gradient(281deg, #F9EDD4 16.16%, #F8EBD5 30.62%, #F8DED4 45.09%, #EDCFEC 59.56%, #D9D4F9 73.8%, #D3DAFE 88.49%)',
      backgroundPosition: '0 100px',
      backgroundRepeat: 'no-repeat',
      borderBottomLeftRadius: '1rem',
      borderBottomRightRadius: '1rem'
    }}
    >
      <img src={imgLogo} />

      <Chip
        sx={{
          mt: 1
        }}
        variant='active'
        label='Premium AI+'
      />

      {data?.products.map((product) => (
        <>
          <Box
            sx={{
              pt: '2rem',
              textAlign: 'center',
              maxWidth: '43rem'
            }}
          >
            <Typography
              variant='h1'
              sx={{
                pb: '1rem'
              }}
            >
              {product.name}
            </Typography>

            <Typography variant='activitySubHeaderPrimary'>
              {product.description}
            </Typography>
          </Box>

          <Stack
            direction='row'
            justifyContent='space-around'
            sx={{
              pt: '2.75rem',
              width: '100%',
              maxWidth: '45rem',
              pb: '4.75rem'
            }}
          >
            <Stack gap={2}>
              <ValuePropositionText label='Deep analysis of trusted data.' />
              <ValuePropositionText label='Your 24/7 research analyst.' />
            </Stack>

            <Stack gap={2}>
              <ValuePropositionText label='No hallucinations, no prompting required.' />
              <ValuePropositionText label='Secure and compliant: protect your IP.' />
            </Stack>
          </Stack>

          <Stack
            direction='row'
            gap='1.69rem'
            justifyContent='center'
            sx={{
              width: '100%',
              maxWidth: '43rem'
            }}
          >
            {product.prices.map((price) => (
              <Card
                key={price.id}
                sx={{
                  minWidth: '18rem'
                }}
              >
                <CardContent>
                  <Stack gap='1rem'>
                    <Box>
                      <Chip
                        variant='active'
                        label={price.interval === 'monthly' ? 'Most flexible' : 'Best value'}
                      />
                    </Box>

                    <Typography variant='activityHeader'>
                      {_.upperFirst(price.interval)}
                    </Typography>

                    {price.tiers.map((t, i) => (
                      <Typography
                        variant='formLabel'
                        key={i}
                      >
                        ${t.unitAmount.toFixed(2)}/{price.formattedUnitInterval} | {`Billed ${price.interval}`}
                      </Typography>
                    ))}

                    <Button
                      size='small'
                      variant='contained'
                      disabled={props.disableButtons}
                      onClick={() => {
                        if (props.onSelectPrice) {
                          props.onSelectPrice(price);
                        }
                      }}
                    >
                      Purchase
                    </Button>
                  </Stack>
                </CardContent>
              </Card>
            ))}
          </Stack>
        </>
      ))}
    </Box>
  );
};



function ValuePropositionText({
  label
}: {
  label: string;
}) {
  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 0.5
    }}
    >
      <CheckCircle color='primary' />

      <Typography variant='activitySubHeaderPrimary'>
        {label}
      </Typography>
    </Box>
  );
}

